import { Text } from '@kui-react/text';
import { Select } from '@kui-react/select';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LanguageContext } from '../IntlWrapper';

import './index.css';
import { getRuntimeEnv } from '../../utils/env';

// KUI version from package.json (representative version)
const KUI_VERSION = '4.132.9';

// Show version info in development and staging (runtime: staging host or REACT_APP_ENV=staging)
function showVersionInfo() {
  if (process.env.NODE_ENV !== 'production') return true;
  return getRuntimeEnv() === 'staging';
}

export const PageFooter = () => {
  
  const {
    language,
    availableLanguages,
    changeLanguage
  } = useContext(LanguageContext);

  const isInWebAppiOS = window.navigator.standalone === true;
  const mql = window.matchMedia('(display-mode: standalone)');
  const isInWebAppChrome = mql.matches;
  const target = isInWebAppiOS || isInWebAppChrome ? '_self' : '_blank';

  return (
      <div className='footer-container'>
        <div className='footer-active'>
          <div className='footer-text'>
            <div className='footer-links'>
              <Text className='footer-link' as='a' href='https://www.nvidia.com/privacy' target={target} rel='noreferrer'>
                <FormattedMessage id='privacy-policy' defaultMessage='Privacy Policy' />
              </Text>
              <span className='footer-dividers'>|</span>
              <Text className='footer-link' as='a' href='https://www.nvidia.com/legal' target={target} rel='noreferrer'>
                <FormattedMessage id='legal-info' defaultMessage='Legal Info' />
              </Text>
              <span className='footer-dividers'>|</span>
              <Text className='footer-link' as='a' href='https://www.nvidia.com/contact' target={target} rel='noreferrer'>
                <FormattedMessage id='contact-us' defaultMessage='Contact Us' />
              </Text>
            </div>
            <div className='footer-copyright'>
              Copyright &#169; {new Date().getFullYear()} NVIDIA Corporation
              {showVersionInfo() && (
                <span className='footer-version'> | KUI v{KUI_VERSION}</span>
              )}
            </div>
          </div>
          <div className='footer-language'>
            <Select
              onChange={changeLanguage}
              options={availableLanguages}
              value={language}
              css={{ 
                minWidth: '140px',
                'button': { 
                  border: 0, 
                  minWidth: '140px',
                  backgroundColor: '#212121',
                  '&:hover': { border: 0, borderColor: 'transparent', backgroundColor: '#212121', color: '#fafafa' },
                  '&:focus': { backgroundColor: '#212121' },
                  '&[data-state="open"]': { backgroundColor: '#212121' }
                }
              }}
            />
          </div>
        </div>
    </div>
  );
};

export default PageFooter;

